import * as React from "react";
import { IDockviewPanelProps } from "dockview";
import { observer } from "mobx-react-lite";
import {
  Dataset,
  Field,
  getStore,
  Table,
} from "bundles/BigqueryQueryViewer/store";
import styles from "./style.module.css";
import I18n from "lib/I18n";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { call } from "lib/apiHelper";
import { BigqueryApi as Api, BigqueryTable } from "lib/Api";

interface FieldProps {
  field: Field;
  prefix: string;
  depth: number;
}

export const FieldComponent = observer((props: FieldProps) => {
  const { field, prefix, depth } = props;
  return (
    <div className={depth > 0 ? "ms-5" : ""}>
      <Row className="mb-2">
        <Col xs={2}>
          <Form.Control size="sm" type="text" readOnly value={field.name} />
        </Col>
        <Col xs={2}>
          <Form.Control size="sm" type="text" readOnly value={field.type} />
        </Col>
        <Col xs="auto">
          <Form.Check
            className="mt-1"
            type="checkbox"
            id={`${prefix}-repeated`}
            label={I18n.t("event_master_editor.label.repeated")}
            readOnly
            checked={field.repeated}
            onChange={(e) => (e.target.checked = field.repeated)}
          />
        </Col>
        <Col xs={6}>
          <Form.Control
            size="sm"
            as="textarea"
            rows={1}
            className={styles.descriptionCell}
            readOnly
            value={field.description ?? ""}
          />
        </Col>
      </Row>
      {field.type == "RECORD" && (
        <div>
          {(field.fields ?? []).map((field, i) => (
            <FieldComponent
              field={field}
              prefix={`${prefix}-${field.name}-${i}`}
              key={i}
              depth={depth + 1}
            />
          ))}
        </div>
      )}
    </div>
  );
});

export const TableComponent = observer(
  (props: IDockviewPanelProps<{ dataset: Dataset; table: Table }>) => {
    const { dataset, table } = props.params;
    const app = getStore().app;
    const [tableStat, setTableStat] = useState<BigqueryTable | undefined>(
      undefined,
    );

    useEffect(() => {
      (async () => {
        const response = await call(
          Api.indexTitlesBigqueryTable(app.titleUuid, app.env),
        );
        if (response.code == 200) {
          setTableStat(
            response.body.find((_) => {
              const splits = _.name.split("_");
              return splits.slice(0, splits.length - 1).join("_") == table.name;
            }),
          );
        }
      })();
    }, []);

    return (
      <div className={styles.root}>
        <div className={styles.block}>
          <h4>{I18n.t("bigquery_query_viewer.label.table_info")}</h4>
          <Container fluid>
            <p>{table.description}</p>
            <Row>
              <Col xs="3">
                {I18n.t("bigquery_query_viewer.label.dataset_id")}
              </Col>
              <Col xs="9">{dataset.name}</Col>
            </Row>
            <Row>
              <Col xs="3">{I18n.t("bigquery_query_viewer.label.table_id")}</Col>
              <Col xs="9">{table.name}</Col>
            </Row>
            <Row>
              <Col xs="3">{I18n.t("bigquery_table_viewer.label.rows")}</Col>
              <Col xs="9">{tableStat?.rows}</Col>
            </Row>
            <Row>
              <Col xs="3">
                {I18n.t("bigquery_table_viewer.label.used_size")}
              </Col>
              <Col xs="9">{tableStat?.usedSize}</Col>
            </Row>
          </Container>
        </div>
        <div className={styles.block}>
          <h4>{I18n.t("bigquery_query_viewer.label.schema")}</h4>
          <Container fluid>
            {table.fields.map((field, i) => (
              <FieldComponent
                key={i}
                field={field}
                prefix={i.toString()}
                depth={0}
              />
            ))}
          </Container>
        </div>
      </div>
    );
  },
);
